import { type Level, stars } from '@xox/shared'
import { readJson, writeJson } from '../lib/storage'

interface LevelProgress {
  bestMoves: number
  stars: 1 | 2 | 3
}

export type Progress = Record<string, LevelProgress>

const KEY = 'xox-ice-progress'

export function loadProgress(): Progress {
  return readJson<Progress>(KEY, {})
}

export function saveProgress(p: Progress) {
  writeJson(KEY, p)
}

/** Keeps the best (fewest-move) result per level. */
export function recordResult(p: Progress, levelId: string, moves: number, par: number): Progress {
  const prev = p[levelId]
  if (prev && prev.bestMoves <= moves) return p
  return { ...p, [levelId]: { bestMoves: moves, stars: stars(moves, par) } }
}

/** The first level is always open; each further level unlocks once the previous one is done. */
export function isUnlocked(p: Progress, levels: readonly Level[], levelId: string): boolean {
  const i = levels.findIndex((l) => l.id === levelId)
  if (i <= 0) return i === 0
  const prev = levels[i - 1]
  return prev !== undefined && p[prev.id] !== undefined
}

/** Cleared count plus the next level to play: the first unlocked level not yet cleared. */
export function summarizeProgress(
  p: Progress,
  levels: readonly Level[],
): { cleared: number; next: Level | undefined; nextNumber: number } {
  const cleared = levels.filter((l) => p[l.id] !== undefined).length
  const i = levels.findIndex((l) => !p[l.id] && isUnlocked(p, levels, l.id))
  return { cleared, next: levels[i], nextNumber: i + 1 }
}
